import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import CommonIcon from '@/components/CommonIcon';
import { isMobile } from '@/utils';
import Styles from './mIndex.module.scss';

interface IEmptyThreadTipsProps {
  textKey?: string;
}

const EmptyThreadTips = ({ textKey = 'label_empty_thread_title' }: IEmptyThreadTipsProps) => {
  const t = useTranslations();
  const router = useRouter();

  const handleClickBack = () => {
    router.push('/');
  };

  return (
    <div className={Styles.root}>
      <div className={Styles.icon}>
        <CommonIcon icon="empty-thread" />
      </div>
      <div className={Styles.title}>{t(textKey)}</div>
      {/* <div className={Styles.desc}>{t('label_empty_thread_desc')}</div> */}
      {isMobile && <div className={Styles.button} onClick={handleClickBack}>{t('btn_back_home')}</div>}
    </div>
  );
};

export default EmptyThreadTips;
